import React from 'react';
import moment from 'moment';

export const options = {
  columns: [
    { id: 1, name: '', label: '', sortable: false },
    { id: 2, name: 's.no', label: 'S.NO.', sortable: false, type: 'number' },
    { id: 3, name: 'tenantName', label: 'TENANT NAME', sortable: true, type: 'string' },
    { id: 4, name: 'parentTenantName', label: 'PARENT TENANT NAME', type: 'string' },
    { id: 5, name: 'tenantType', label: 'TENANT TYPE', sortable: true, type: 'string', component: (row) => <div className='text-center'>{row.tenantType && row.tenantType == 'DSP/Ad network' ? 'Agency' : row.tenantType == 'Advertiser & DSP/Ad network' ? 'Advertiser & Agency' : row.tenantType}</div> },
    { id: 6, name: 'platform', label: 'PLATFORM', type: 'string' },
    { id: 7, name: 'country', label: 'TENANT CATEGORY', sortable: true, type: 'string', component: (row) => <div className="text-capitalize">{row.accountType ? "Account" : "Tenant"}</div> },
    // { id: 7, name: 'state', label: 'State', sortable: true, type: 'string', component: (row) => <div className="text-capitalize">{row.state}</div> },
    // { id: 8, name: 'city', label: 'City', sortable: true, type: 'string', component: (row) => <div className="text-capitalize">{row.city}</div> },
    { id: 8, name: 'contactPerson', label: 'CONTACT PERSON', type: 'string' },
    { id: 9, name: 'contactEmail', label: 'CONTACT EMAIL', type: 'string' },
    { id: 10, name: 'modifiedOn', label: 'UPDATED ON', sortable: true, type: 'date', component: (row) => moment(row.modifiedOn).format('YYYY-MM-DD') },
    { id: 11, name: 'balance', label: 'CREDIT BALANCE', type: 'number', component: (row) => <div className='text-center'>{row.balance ? row.balance.toFixed(2) : '-'}</div> },
    { id: 12, name: 'isPrimary', label: 'IS PRIMARY', type: 'string', component: (row) => <div className="text-capitalize">{row.isPrimary == '1' ? "Yes" : "No"}</div> },
  ],

  keyCol: 'tenantId',
  actions: [
    {
      type: 'edit',
      text: '',
      icon: 'ti ti-pencil color-beki',
      tooltip: 'Edit',
      iconType: 'new'
    },
    {
      type: 'view',
      text: '',
      icon: 'ti ti-eye color-beki',
      tooltip: 'View Tenant',
      iconType: 'new'
    }
  ],
  recActive: true,
  status: {
    key: 'isActive',
    active: '1',
    activeIcon: 'mdi mdi-check-circle',
    inActiveIcon: 'mdi mdi-minus-circle',
    // confirmation: true,
    // activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    // inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
    type: "recActive"
  },
  showSwitch: true,
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'createdOn',
    sortOrder: 'desc'
  },
  showSearch: true,
  searchable: true,
  searchColumns: [
    { key: 'tenantName' },
    { key: 'contactPerson' },
    { key: 'parentTenantName' },
    { key: 'contactEmail' },
    { key: 'platform' },
    { key: 'tenantType' }
  ],
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
}


export const SsOptions = {
  columns: [
    { id: 1, name: '', label: '', sortable: false },
    { id: 2, name: 's.no', label: 'S.NO.', sortable: false, type: 'number' },
    { id: 3, name: 'tenantName', label: 'TENANT NAME', sortable: true, type: 'string' },
    { id: 3, name: 'parentTenantName', label: 'PARENT TENANT NAME', type: 'string' },
    { id: 4, name: 'tenantType', label: 'TENANT TYPE', sortable: true, type: 'string' },
    { id: 5, name: 'platform', label: 'PLATFORM', type: 'string' },
    { id: 6, name: 'country', label: 'TENANT CATEGORY', sortable: true, type: 'string', component: (row) => <div className="text-capitalize">{row.accountType ? "Account" : "Tenant"}</div> },
    // { id: 7, name: 'state', label: 'State', sortable: true, type: 'string', component: (row) => <div className="text-capitalize">{row.state}</div> },
    // { id: 8, name: 'city', label: 'City', sortable: true, type: 'string', component: (row) => <div className="text-capitalize">{row.city}</div> },
    { id: 9, name: 'contactPerson', label: 'CONTACT PERSON', type: 'string' },
    { id: 10, name: 'contactEmail', label: 'CONTACT EMAIL', type: 'string' },
    { id: 11, name: 'modifiedOn', label: 'UPDATED ON', sortable: true, type: 'date', component: (row) => moment(row.modifiedOn).format('YYYY-MM-DD') },
    { id: 6, name: 'isPrimary', label: 'IS PRIMARY', type: 'string', component: (row) => <div className="text-capitalize">{row.isPrimary == '1' ? "Yes" : "No"}</div> },
  ],

  keyCol: 'tenantId',
  actions: [
    //   {
    //   type: 'edit',
    //   text: '',
    //   icon: 'mdi mdi-pencil',
    //   tooltip: 'Edit'
    // },
    {
      type: 'view',
      text: '',
      icon: 'ti ti-eye color-beki',
      tooltip: 'View Tenant',
      iconType: 'new'
    }],
  recActive: true,
  status: {
    key: 'isActive',
    active: '1',
    activeIcon: 'mdi mdi-check-circle',
    inActiveIcon: 'mdi mdi-minus-circle',
    // confirmation: true,
    // activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    // inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
    type: "recActive"
  },
  showSwitch: true,
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'createdOn',
    sortOrder: 'desc'
  },
  showSearch: true,
  searchable: true,
  searchColumns: [
    { key: 'tenantName' },
    { key: 'contactPerson' },
    { key: 'parentTenantName' },
    { key: 'contactEmail' },
    { key: 'platform' },
    { key: 'tenantType' }
  ],
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
}






export const formFields = {
  category: {
    key: 'category',
    label: 'Tenant type',
    // placeholder: 'Both',
    displayLayout: 'col-md-12',
    labelLayout: 'col-md-12  justify-content-start',
    tooltip: '<div>category </div>'
  },
  status: {
    key: 'status',
    label: 'Status',
    // placeholder: 'Both',
    displayLayout: 'col-md-12',
    labelLayout: 'col-md-12  justify-content-start',
    tooltip: '<div>status </div>'
  },
  platform: {
    key: 'platform',
    label: 'Platform',
    placeholder: 'Search & Single Select',
    required: false,

    displayLayout: 'col-md-12 ',
    labelLayout: 'col-md-12  justify-content-start',
    tooltip: '<div>platform </div>'
  },
}
export const statusOptions = [
  { id: 2, value: "Both" },
  { id: 1, value: 'Active' },
  { id: 0, value: 'InActive' }
];

export const categoryOptions = [
  { id: 2, value: "Both" },
  { id: 1, value: 'Account' },
  { id: 0, value: 'Tenant' }
];

